<template>
   <div class='Enviadas'>
    <div v-if="loading">
        <div class="d-flex justify-content-center mt-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
    <div v-else>
        <div v-if="projectos == null">
            <div class="row pt-3">
                <div class="col">
                    <div class="card">
                        <p class="text-center pt-2">Sin Proyectos</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <table class="table">
            <thead>
                <tr>
                    <th scope="col">Nombre Proyecto</th>
                    <th scope="col">Solicitante</th>
                    <th scope="col">Pais</th>
                    <th scope="col" class="text-center">Archivo</th>
                    <th scope="col">Fecha Inicio</th>
                    <th scope="col">Fecha Entrega</th>
                    <th scope="col">Fecha Vigencia</th>
                    <th scope="col">Monto</th>
                    <th scope="col">Concesión</th>
                    <th scope="col" class="text-center">Acciones</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="f in projectos" :key="f.id_oferta" :class="f.reoferta == '1' ? 'table-warning' : ''">
                    <td>
                        <router-link :to="{ name: 'DetalleProyecto', params: { idEmpresa: f.id_proyecto}}">
                            {{f.titulo_proyecto}}
                        </router-link>
                        <span v-if="f.nuevos_comentarios > 0" style="color:#fd7e14">
                            <font-icon icon="blog"/>
                            {{f.nuevos_comentarios}}
                        </span>
                        <span v-else>
                            <font-icon icon="blog"/>
                        </span>
                    </td>
                    <td>
                        <div class="row">
                            <div class="col-sm-3">
                                <img :src="getUrl(f.avatar)" class="img">
                            </div>
                            <div class="col-sm-9">
                                <router-link :to="{ name: 'calificacion', params: {id: f.id_user}}">
                                    @{{f.usuario}}
                                </router-link>
                                <star-rating :increment="0.1" :rating="makeNumber(f.estrellas)" :star-size="20" :show-rating="false" :read-only="true"/>
                            </div>
                        </div>
                    </td>
                    <td>
                        <img :src="getBandera(f.pais_region)" class="bandera">
                    </td>
                    <td>
                        <p class="text-center pointer" v-if="f.adjuntoOriginalOferta.length > 0">
                            <font-icon icon="file-pdf" class="pdf" @click="descargarFile(f.adjuntoOriginalOferta)"/>
                        </p>
                        <p v-else class="text-center">
                            Sin Adjunto
                        </p>
                    </td>
                    <td>{{fechaFormat(f.fecha_iniciop)}}</td>
                    <td>{{fechaFormat(f.fecha_termino)}}</td>
                    <td>{{fechaFormat(f.vigencia)}}</td>
                    <td>
                        ${{moneda(f.costo)}} <small>USD</small> <br/>
                        <span class="badge badge-warning" v-if="f.reoferta == '1'">
                            En re-oferta
                        </span>
                        <span class="badge badge-primary" v-if="f.reoferta == '0' && f.reofertado == 1">
                            Nueva oferta
                        </span>
                    </td>

                    <!--CONCESION-->
                    <td v-if="f.reoferta == 1">
                        <button class="btn btn-secondary btn-block btn-sm" v-if="!cargando" @click="validarMembresia(f)">
                            Re-Ofertar
                        </button>
                         <button class="btn btn-secondary btn-block btn-sm" v-else disabled>
                            Cargando...
                        </button>
                    </td>
                    <td v-else></td>

                    <!--ACCIONES -->
                    <td class="text-center">
                        <button class="btn btn-sm btn-danger" @click="borrar(f.id_oferta)" data-toggle="tooltip" title="Borrar Propuesta">
                            <font-icon icon="trash-alt"/>
                        </button>

                        <button class="btn orange btn-sm" @click="regChat(f)" v-if="f.chatactivo == '1'" title="Chat">
                            <font-icon icon="comments"/>
                        </button>
                        <button class="btn orange btn-sm" disabled v-else>
                            <font-icon icon="comments"/>
                        </button>

                    </td>

                </tr>
            </tbody>
            </table>
        </div>
    </div>


    <!--Modal Postularte-->
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog">
        <div class="modal-content">
        <div class="modal-header orange">
            <span>Nueva propuesta para el proyecto: </span>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <form @submit="validar">
            <div class="modal-body">
                <h4 class="text-center">{{nombre}}</h4>
                <hr>
                <div class="alert alert-warning" role="alert" v-show="membresia.valida == 0">
                    Lo sentimos, tu membresía es {{ membresia.tipo }} por lo que no puedes hacer una oferta para este proyecto.
                    Para poder hacer una oferta puedes hacer un <a href="#" @click="cerrarModal()">Upgrade</a> a tu membresia.
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <h6><b>Precio en USD</b></h6>
                            <input type="number" v-model="precio" class="form-control" placeholder="Precio de la obra" required/>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <h6><b>Fecha Entrega</b></h6>
                            <input type="text" :value="fechaFormat(fechaCierre)" class="form-control" disabled/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                    <div class="form-group">
                        <h6><b>Fecha Inicio</b></h6>
                        <input type="date" v-model="tiempoEntrega" class="form-control" required/>
                    </div>
                    </div>

                    <div class="col-sm-6">
                    <div class="form-group">
                        <h6><b>Vigencia de tu propuesta</b></h6>
                        <input type="date" v-model="vigencia" class="form-control" placeholder="ej. 90" required/>
                    </div>
                    </div>
                </div>

                <div class="form-group">
                    <h6><b>Describe tus fortalezas para ejecutar este proyecto:</b> <br> <small>(Máximo 140 caracteres)</small> </h6>
                    <textarea class="form-control" rows="3" v-model="propuesta" maxlength="140"
                        required placeholder="¿Que te hace un buen candidato para este trabajo?">
                    </textarea>
                </div>

                <div class="row">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <h6><b>Adjunto Original</b></h6>
                            <span v-if="adjunto">
                                <font-icon class="pointer" icon="file-pdf" style="font-size:28px" @click="descargarFile(adjunto)"/>
                            </span>
                            <span v-else>
                                <small>Sin Adjunto</small>
                            </span>

                        </div>
                    </div>
                    <div class="col-sm-8">
                        <div class="form-group">
                            <h6><b>Adjuntar Nuevo Documento</b></h6>
                            <input type="file" class="form-control" @change="addFile">
                        </div>
                    </div>
                </div>

                 <small class="warning-font">
                    *Debe tener en consideración que, dependiendo del método que elija para recibir el pago de sus servicios, las
                    Instituciones involucradas en la transacción, pueden aplicar algunas tarifas que son independientes a nuestros
                    servicios y le serán descontadas cuando estas apliquen.
                </small> <br>
                </div>

            <div class="modal-footer">
                <a class="mr-auto" style="font-size: 12px" :href="urlWeb+ '/assets/pdf/politicaCargosTarifas.pdf'" target="_blank">
                    Ver Politicas de Cargos y Tarifas
                </a>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                <button type="submit" v-if="!botonCargando" class="btn orange" :disabled='membresia.valida == 0'>Aceptar</button>
                <button type="button" v-else class="btn orange" disabled >Cargando...</button>
            </div>
        </form>
        </div>
    </div>
    </div>

   </div>
</template>


<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'
import $ from 'jquery'
import StarRating from 'vue-star-rating'

export default {
name: 'Enviadas',
components:{StarRating},
mixins: [ globalFunctions ],
data () {
    return {
        projectos: [],
        loading: true,
        precio: "",
        tiempoEntrega: "",
        propuesta: "",
        divisa: "MXN",
        vigencia: null,
        idEmpresa : '',
        fechaCierre : '',
        membresia: '',
        btnText : 'Hacer Propuesta',
        nombre : '',
        adjunto: '',
        cargando: false,
        botonCargando: false,
        adjuntoOferta: '',
        selectedFile: null,
        fileName: '',
        pais: '',
    }
},
methods: {

    getData(){
        let data = {
            id: localStorage.userID,
            prop: 1,
            flag:3
        };

        this.axios.post(this.url + 'getProyectos.php',data).then((responce) =>{
            this.projectos = responce.data;
            this.loading = false;
            this.$emit("update");
        });
    },

    addFile(event){
        this.selectedFile = event.target.files[0];
        this.fileName = this.selectedFile.name;
    },

    validar(e){
        e.preventDefault();

        if(this.tiempoEntrega >= this.fechaCierre){
            this.msjError("Fecha de Inicio es mayor o igual a la fecha de Entrega.");
            return;
        }

        if(this.vigencia > this.fechaCierre){
            this.msjError("Fecha de Vigencia es mayor a la fecha de Entrega");
            return;
        }

        if(this.precio <= 0){
            this.msjError("Precio debe ser mayor a $0");
            return;
        }

        if(this.selectedFile != null) //Validar que sea pdf
        {
            let archivo = this.selectedFile.name;
            let index = archivo.length;
            index = index - 4;
            var res = archivo.substr(index, 4);

            res.toLowerCase();

            if(res != '.pdf'){
                this.msjError("Solo se acepta archivos con formato PDF");
                this.cargandoSegundoBtn = false
                return;
            }
        }

        this.altaArchivo();
    },

    regChat(f){
        this.$router.push('/Blog?tabla=' + f.id_user + '&tabla2=' + f.id_proyecto);
    },


    altaArchivo(){
        this.botonCargando = true;

        if(this.selectedFile != null) //Validar que sea pdf
        {
            //Insertar en Server
            const fd = new FormData();
            fd.append('file',this.selectedFile, this.selectedFile.name);

            this.axios.post(this.url + 'altaArchivo.php', fd, {
                header:{
                    'Content-Type': 'multipart/form-data'
                }
            }).then((responce) =>{
                if(responce.data.res == '200'){
                    let fileName = responce.data.nombre;
                    this.altaPropuesta(fileName);
                }else{
                    alert("Error");
                }
            });
        } else {
            this.altaPropuesta();
        }

    },

    altaPropuesta(filename=0) {

        let data = {
            precio: this.precio,
            tiempo1: this.tiempoEntrega,
            tiempo2: this.fechaCierre,
            propuesta: this.propuesta,
            idEmp: this.idProyecto,
            idPropuesta: localStorage.userID,
            divisa: this.divisa,
            vigencia: this.vigencia,
        };

        if(filename == 0){
            data.newFileName = this.adjunto;
            data.fileName = this.adjuntoOferta
        } else { //Contenga Nuevo Archivo
            data.newFileName = filename;
            data.fileName = this.fileName;
        }

        this.axios.post(this.url + "altaPropuesta.php", data).then((responce) => {
            if (responce.data > 0) {
                this.precio = "";
                this.tiempoEntrega = "";
                this.propuesta = "";
                this.vigencia = "";
                this.enviarCorreo(14, 'Recepción de re-oferta', this.idProyecto, responce.data); //-- responce.data retorna el ultimo id de propuesta
                this.msjOk("Tu propuesta ha sido enviada");
                $("#exampleModal").modal("hide");
                this.getData();
                this.botonCargando = false;
            }else {
                this.msjError('La fecha de inicio del proyecto no debe ser menor a la actual');
                this.botonCargando = false;
            }
        });
    },

    validarMembresia(f) {
        this.cargando = true;

        let data = {
            idProyecto:f.id_proyecto,
            idUsuario: localStorage.userID
        }

        this.axios.post(this.url + 'getValidaMembresia.php', data).then((responce) =>{
            this.membresia = responce.data[0];
            this.validarPostulacion(f);
        });
    },

    validarPostulacion(f){

        //Verficiar si ya se postulo
        let user = {
            id: localStorage.userID,
            idEmp: f.id_proyecto,
            flag: '7'
        }

        this.axios.post(this.url + 'consultasBasicas.php', user).then((responce) =>{
            if(responce.data != null){
                this.$swal.fire('Ya has enviado una propuesta anteriormente para este proyecto.')
                this.cargando = false;
            }else{
                $("#exampleModal").modal("show");
                //this.enviarCorreo(14, 'Recepcion de re-oferta', f.id_proyecto);
                this.cargando = false;
                this.nombre = f.titulo_proyecto;
                this.fechaCierre = f.fecha_termino;
                this.precio = f.costo;
                this.divisa = f.divisa;
                this.tiempoEntrega = f.fecha_iniciop;
                this.propuesta = f.notaPropuesta;
                this.idProyecto = f.id_proyecto;
                this.adjunto = f.adjuntoOriginalOferta;
                this.adjuntoOferta = f.adjuntoOferta;
            }
        });
    },
    borrar(id){
        this.$swal.fire({
            title: '¿Estas Seguro?',
            text: "Ya no podras revertir el cambio",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, borrar oferta!'
        }).then((result) => {
            if (result.isConfirmed) {
                let data = {
                    flag:8,
                    id //id proyecto
                };

                this.axios.post(this.url + 'postProyectos.php', data).then((responce) =>{
                    if(responce.data == 200){
                        this.$swal.fire(
                            'Eliminado!',
                            'Tu oferta ha sido eliminada.',
                            'success'
                        );
                        this.getData();
                    }
                });
            }
        })
    },

    /*vercargosytarifas(){
        $("#exampleModal").modal('hide');
        //this.$router.push({ name: 'pagos'});
    },*/
},
computed:{
    ...mapState(['url','urlWeb'])
},
mounted(){
    this.getData();
}
}
</script>


<style scoped>
.table{
    background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/Proyectos/components/Consultor/Enviadas.vue